/** @type {import('./check-ignore').IgnoreDefinition[]} */
const ignoreList = [
  {
    message: {
      is: 'Script error.'
    }
  },
  {
    message: {
      is: 'Network Error'
    }
  },
  {
    message: {
      includes: '__firefox__'
    }
  },
  {
    // Cyclic-structure JSON.stringify errors thrown inside the third-party tag pipeline
    // (Cloudflare Zaraz / GTM / Kameleoon serializing DOM nodes).
    message: {
      includes: ['cyclic', 'circular']
    },
    stack: {
      includes: 'zaraz'
    }
  },
  // unhandled rejections from third-party requests blocked by ad blockers or network issues ('Load failed' is the Safari equivalent)
  {
    message: {
      is: 'Failed to fetch'
    },
    isUncaught: true
  },
  {
    message: {
      is: 'Load failed'
    },
    isUncaught: true
  },
  // unhandled 401 rejections: the axios interceptor already logs the user out
  {
    message: {
      is: 'Request failed with status code 401'
    },
    isUncaught: true
  },
]
export default ignoreList
